import { ApplicationBuildServiceData } from 'services/GameHosting/ApplicationBuild/applicationBuildServiceType';
import { SortParams } from 'types/common/sorting';
import { ApplicationBuildProperty } from 'types/GameHosting/application-build';
import { ChangeAction, FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_APPLICATION_BUILD_PROPERTIES = 'FETCH_APPLICATION_BUILD_PROPERTIES';

export const FETCH_APPLICATION_BUILD_PROPERTIES_IS_PENDING = 'FETCH_APPLICATION_BUILD_PROPERTIES_IS_PENDING';

export const FETCH_APPLICATION_BUILD_PROPERTIES_IS_ERROR = 'FETCH_APPLICATION_BUILD_PROPERTIES_IS_ERROR';

export const FETCH_APPLICATION_BUILD_BY_ID = 'FETCH_APPLICATION_BUILD_BY_ID';

export const FETCH_APPLICATION_BUILD_BY_ID_IS_PENDING = 'FETCH_APPLICATION_BUILD_BY_ID_IS_PENDING';

export const FETCH_APPLICATION_BUILD_BY_ID_IS_ERROR = 'FETCH_APPLICATION_BUILD_BY_ID_IS_ERROR';

export const CLEAN_APPLICATION_BUILD_PROPERTIES = 'CLEAN_APPLICATION_BUILD_PROPERTIES';

export const FETCH_APPLICATION_BUILDS = 'FETCH_APPLICATION_BUILDS';

export const FETCH_APPLICATION_BUILDS_IS_PENDING = 'FETCH_APPLICATION_BUILDS_IS_PENDING';

export const FETCH_APPLICATION_BUILDS_IS_ERROR = 'FETCH_APPLICATION_BUILDS_IS_ERROR';

export const CREATE_APPLICATION_BUILD = 'CREATE_APPLICATION_BUILD';

export const CREATE_APPLICATION_BUILD_IS_PENDING = 'CREATE_APPLICATION_BUILD_IS_PENDING';

export const CREATE_APPLICATION_BUILD_IS_ERROR = 'CREATE_APPLICATION_BUILD_IS_ERROR';

export const UPDATE_APPLICATION_BUILD = 'UPDATE_APPLICATION_BUILD';

export const UPDATE_APPLICATION_BUILD_IS_PENDING = 'UPDATE_APPLICATION_BUILD_IS_PENDING';

export const UPDATE_APPLICATION_BUILD_IS_ERROR = 'UPDATE_APPLICATION_BUILD_IS_ERROR';

export const UPDATE_APPLICATION_BUILD_PROPERTIES = 'UPDATE_APPLICATION_BUILD_PROPERTIES';

export const UPDATE_APPLICATION_BUILD_PROPERTIES_IS_PENDING = 'UPDATE_APPLICATION_BUILD_PROPERTIES_IS_PENDING';

export const UPDATE_APPLICATION_BUILD_PROPERTIES_IS_ERROR = 'UPDATE_APPLICATION_BUILD_PROPERTIES_IS_ERROR';

export const DELETE_APPLICATION_BUILD = 'DELETE_APPLICATION_BUILD';

export const DELETE_APPLICATION_BUILD_IS_PENDING = 'DELETE_APPLICATION_BUILD_IS_PENDING';

export const DELETE_APPLICATION_BUILD_IS_ERROR = 'DELETE_APPLICATION_BUILD_IS_ERROR';

export const SORT = 'SORT_APPLICATION_BUILDS';

export const CLEAN_ERROR = 'CLEAN_ERROR_APPLICATION_BUILDS';

export type ApplicationBuildReducerState = {
  /**
   * Application builds
   */
  applicationBuilds: ApplicationBuildServiceData[];
  /**
   * Application build properties
   */
  applicationBuildProperties: ApplicationBuildProperty[] | undefined;
  /**
   * Application build
   */
  applicationBuildById: ApplicationBuildServiceData | undefined;
} & FetchReducer<
  | 'fetchApplicationBuildById'
  | 'fetchApplicationBuildProperties'
  | 'updateApplicationBuild'
  | 'createApplicationBuild'
  | 'deleteApplicationBuild'
  | 'fetchApplicationBuilds'
  | 'updateApplicationBuildProperties'
> &
  SortState<ApplicationBuildServiceData>;

export type ApplicationBuildActions =
  | FetchAction<'FETCH_APPLICATION_BUILDS', ApplicationBuildServiceData[]>
  | FetchAction<'FETCH_APPLICATION_BUILD_PROPERTIES', ApplicationBuildProperty[]>
  | ChangeAction<'UPDATE_APPLICATION_BUILD_PROPERTIES'>
  | FetchAction<
      'CREATE_APPLICATION_BUILD' | 'UPDATE_APPLICATION_BUILD' | 'DELETE_APPLICATION_BUILD' | 'FETCH_APPLICATION_BUILD_BY_ID',
      ApplicationBuildServiceData
    >
  | { type: 'CLEAN_ERROR_APPLICATION_BUILDS'; errorIndex: number; reducerProperty: keyof ApplicationBuildReducerState }
  | { type: 'RESET_APPLICATION_BUILD_REDUCER' }
  | ResetReducerAction
  | { type: 'SORT_APPLICATION_BUILDS'; params: SortParams<ApplicationBuildServiceData> }
  | { type: 'CLEAN_APPLICATION_BUILD_PROPERTIES' };
